module.exports = __webpack_public_path__ + "static/media/er.b3e0c406.webp";